<template>
    <div>
        <div class="columns toolbar-box">
            <div class="column is-3">
                <o-field>
                    <o-select placeholder="Choose Frequency" v-model="frequency" expanded>
                        <option :value="1">Expired</option>
                        <option :value="2">1 Week</option>
                        <option :value="3">2 Weeks</option>
                        <option :value="4">4 Weeks</option>
                    </o-select>
                </o-field>
            </div>
        </div>

        <div class="columns is-multiline">
            <trackings />
            <misc-services />
        </div>

        <div class="columns is-multiline">
            <dot-permits />
            <tco />
        </div>
    </div>
</template>

<script>
    import MiscServices from './../../../components/expirations/MiscServices'
    import DotPermits from './../../../components/expirations/DotPermits'
    import Trackings from './../../../components/expirations/Trackings'
    import Tco from './../../../components/expirations/Tco'

    export default {
        components: {
            MiscServices,
            DotPermits,
            Trackings,
            Tco
        },

        data() {
            return {
                frequency: 1
            }
        },
    }
</script>
